exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog .v-card[data-v-2414beaa]{padding:15px 30px;font-size:15px}.v-dialog .v-card .v-card__title[data-v-2414beaa]{padding-left:0}.modal-btn[data-v-2414beaa]{margin-left:0;background:#006aff!important;color:#fff;border:2px solid #006aff!important;font-size:16px;font-weight:500}.modal-btn[data-v-2414beaa]:hover{background:#fff!important;color:#006aff}.package-note .material-icons[data-v-2414beaa]{color:#006aff;font-size:20px;position:relative;top:4px}.link-box[data-v-2414beaa]{margin:15px auto 30px;padding:15px;background:#f5f5f5;border:1px solid #eee;border-radius:8px}.link-box a[data-v-2414beaa]{color:#006aff!important}", ""]);

// exports
